import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetReferrals = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_REFERRALS
            });
            if (data.status === 'success') {
                dispatch(Action.SetGetReferralsAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetReferrals as SetGetReferrals
}